// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"8d25e184","453":"a3bfcd73","455":"cbbb243a"}[chunkId] + ".chunk.js";
};